import { render } from "./ImageSelector.vue?vue&type=template&id=0525104a&scoped=true"
import script from "./ImageSelector.vue?vue&type=script&lang=js"
export * from "./ImageSelector.vue?vue&type=script&lang=js"

import "./ImageSelector.vue?vue&type=style&index=0&id=0525104a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0525104a"]])

export default __exports__